// import React from "react";
// import { motion } from "framer-motion";

// const faqs = [
//   {
//     question: "What services does Tiranga Express offer?",
//     answer:
//       "We offer a wide range of services including packers and movers, car and bike transportation, cargo services, warehouse storage, pet relocation, and international moving solutions.",
//   },
//   {
//     question: "How can I get instant quotes?",
//     answer:
//       "You can enter your moving details on our platform, and we’ll instantly provide quotes from multiple verified service providers so you can compare and choose the best one.",
//   },
//   {
//     question: "Are your service providers verified?",
//     answer:
//       "Yes, every logistics partner listed on our platform goes through a strict verification process to ensure your safety, trust, and quality service.",
//   },
//   {
//     question: "Can I track my order or shipment?",
//     answer:
//       "Yes, once your order is booked, you can track the status in real-time via your dashboard or mobile app.",
//   },
//   {
//     question: "Is Tiranga Express available across India?",
//     answer:
//       "Absolutely! We provide logistics services pan-India including metro cities, tier-2, and tier-3 towns. We also support international relocations.",
//   },
//   {
//     question: "How do I book a service?",
//     answer:
//       "Select the service you need, fill in the required details, compare quotes, and click on 'Book Now'. Our team will handle the rest for a hassle-free experience.",
//   },
//   {
//     question: "Do you provide customer support?",
//     answer:
//       "Yes, our dedicated 24x7 support team is always ready to assist you with queries, tracking, rescheduling, or service concerns.",
//   },
// ];

// const FAQ = () => {
//   return (
//     <section className="bg-[#f5f7fa] py-16 px-4 md:px-10 text-[#1F1F1F]">
//       <div className="max-w-6xl mx-auto">
//         <motion.h2
//           initial={{ opacity: 0, y: -20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           className="text-4xl md:text-5xl font-bold text-center text-[#004182] mb-8"
//         >
//           Frequently Asked Questions
//         </motion.h2>

//         <div className="space-y-6">
//           {faqs.map((faq, idx) => (
//             <motion.div
//               key={idx}
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ delay: idx * 0.1, duration: 0.5 }}
//               viewport={{ once: true }}
//               className="bg-white rounded-xl shadow-md p-6"
//             >
//               <h3 className="text-xl font-semibold text-[#004182] mb-2">
//                 {faq.question}
//               </h3>
//               <p className="text-gray-700">{faq.answer}</p>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FAQ;

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";

const faqs = [
  {
    question: "What services does Tiranga Express offer?",
    answer:
      "We offer a wide range of services including packers and movers, car and bike transportation, cargo services, warehouse storage, pet relocation, and international moving solutions.",
  },
  {
    question: "How can I get instant quotes?",
    answer:
      "You can enter your moving details on our platform, and we’ll instantly provide quotes from multiple verified service providers so you can compare and choose the best one.",
  },
  {
    question: "Are your service providers verified?",
    answer:
      "Yes, every logistics partner listed on our platform goes through a strict verification process to ensure your safety, trust, and quality service.",
  },
  {
    question: "Can I track my order or shipment?",
    answer:
      "Yes, once your order is booked, you can track the status in real-time via your dashboard or mobile app.",
  },
  {
    question: "Is Tiranga Express available across India?",
    answer:
      "Absolutely! We provide logistics services pan-India including metro cities, tier-2, and tier-3 towns. We also support international relocations.",
  },
  {
    question: "Do you provide customer support?",
    answer:
      "Yes, our dedicated 24x7 support team is always ready to assist you with queries, tracking, rescheduling, or service concerns.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-[#f5f7fa] py-16 px-4 md:px-10 text-[#1F1F1F]">
      <div className="max-w-5xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-4xl md:text-5xl font-bold text-center text-[#004182] mb-10"
        >
          Frequently Asked Questions
        </motion.h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex justify-between items-center text-left px-6 py-4 font-semibold text-[#004182] text-lg"
              >
                {faq.question}
                <span className="text-xl">
                  {openIndex === index ? <ChevronDown /> : <ChevronUp />}
                </span>
              </button>

              <AnimatePresence initial={false}>
                {openIndex === index && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="px-6 pb-4 text-gray-700"
                  >
                    <p>{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
